<template>
  <div>
    <v-wait :for="waiterKeyword">
      <template slot="waiting">
        <div class="container loader">
          <div class="row justify-content-md-center">
            <div class="col-md-auto">
              <spinner></spinner>
            </div>
          </div>
        </div>
      </template>
      <validation-observer v-slot="{handleSubmit}" ref="formValidator">
        <form class="needs-validation" @submit.prevent="handleSubmit(formSubmit)">
          <div class="form-row">
            <div class="col-md-8">
              <base-input
                type="text"
                :label="$t('Block title')"
                :name="$t('Block title')"
                v-model="model.title"
                required
              />
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-8">
              <base-input :label="$t('Description')" :name="$t('Block title')">
                <textarea v-model="model.description" class="form-control" rows="3"></textarea>
              </base-input>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-4">
              <base-checkbox class="mb-3" v-model="model.isVisible">{{ $t('Show status') }}</base-checkbox>
            </div>
          </div>
          <base-button :loading="loading" type="primary" native-type="submit">{{ $t('Save') }}</base-button>
        </form>
      </validation-observer>
    </v-wait>
  </div>
</template>


<script>
import { createNamespacedHelpers } from "vuex";
import { BlockForm } from "../../../mixins/Block/BlockForm";
import {
  FormEdit,
  FormNotification,
  FormSubmitHandlers,
} from "../../../mixins/FormApiHandlers";
import Spinner from "vue-spinner-component/src/Spinner";
const { mapActions, mapState } = createNamespacedHelpers("course/block");

export default {
  name: "FormEditBlock",
  mixins: [BlockForm, FormNotification, FormSubmitHandlers, FormEdit],
  data() {
    return {
      successMessage: this.$i18n.t("Block updated success!"),
      errorMessage: this.$i18n.t("Error on updating block info!"),
      submitRedirectTo: { name: "content", params: this.$route.params },
      waiterKeyword: "block data fetching",
    };
  },
  components: { Spinner },

  computed: {
    ...mapState({
      status: (state) => state.updateStatus.status,
      vuexModel: (state) => state.currentBlock,
    }),
  },

  methods: {
    ...mapActions({
      load: "loadBlock",
      save: "saveBlock",
      revertStatus: "revertUpdateStatus",
    }),
  },
};
</script>

<style scoped lang="scss">
</style>
